import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import styled from "styled-components";
import usePortalService from '../services/PortalService';
import separator from '../images/separator.svg';
import calendar from "../images/calendar.svg";
import { TextPreparator } from '../utils/TextPreparator';
import StudentsNavbar from '../Components/Navbars/StudentsNavbar';
import { Footer } from './StudentPersonalAccount';
import { ParticipateButton } from '../Components/Events/StudentEventCard';
import { CancelButton } from '../Components/Footers/EditInfoFooter';

const Container = styled.a`
    font-family: Open Sans;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
`

const CenterContainer = styled.div `
    margin-bottom: 88px;
    padding-left: 25%;
    padding-right: 25%;
  
    .header {
      font-size: 20px;
      font-weight: 700;
      line-height: 28px;
      color: #222222;
    }
`

const Picture = styled.img `
    border-radius: 8px;
    width: 100%;
    margin-bottom: 20px;
`

const CompanyName = styled.p`
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  color: #45505A;
`

const DateTime = styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #45505A;
`

const getMonthName = (monthIndex: number) => {
  switch (monthIndex) {
    case 0 : return 'января'
    case 1 : return 'февраля'
    case 2 : return 'марта'
    case 3 : return 'апреля'
    case 4 : return 'мая'
    case 5 : return 'июня'
    case 6 : return 'июля'
    case 7 : return 'августа'
    case 8 : return 'сентября'
    case 9 : return 'октября'
    case 10 : return 'ноября'
    case 11 : return 'декабря'
  }
}

let eventId: string;
export const EventStudent = () => {
    const {getEventById, getEventImage} = usePortalService();

    const params = useParams();
    eventId = params.id as string;

    const [coverImage, setCoverImage] = useState('');
    const [eventName, setEventName] = useState('Киберчемпионат «Цифровой технолог РТСИМ. ИТ-парк Казань 2023»');
    const [companyName, setCompanyName] = useState("РТСИМ.Карьера");
    const [date, setDate] = useState(new Date(2023, 8, 21))
    const [description, setDescription] = useState('');
    const [videoLink, setVideoLink] = useState('');
    const [isStudentInvolved, setIsStudentInvolved] = useState(false);

    const [lines, setLines] = useState(2)

    useEffect(() => {
        getEventById(eventId).then(result => {
            setEventName(result.event.name)
            setDate(new Date(result.event.dateTimeOfEvent))
            setCompanyName(result.event.companyName)
            setDescription(TextPreparator.prepare(result.event.detailedDescription))
            getEventImage(result.event.eventCoverImage).then(resImage => {
                setCoverImage(resImage)
            })
            setVideoLink(result.event.videoLink);
            // setIsStudentInvolved(result.event.isStudentInvolved)
        })
    },[])

    return (
        <div style={{backgroundColor: '#F8F8F8'}}>
            <StudentsNavbar />
            <div style={{maxWidth:'983px', paddingTop:'12px', marginLeft:'6%', marginBottom:'12px'}}>
                <Container style={{}}>
                    <Link to="/events" style={{color: '#76838F'}}> События </Link>
                    <img src={separator}/>
                    <Link to="/" style={{color: '#45505A'}}> {eventName} </Link>
                </Container>
            </div>
            <CenterContainer>
                <Picture src={coverImage} />
                <div className="d-flex flex-column" style={{gap: "12px"}}>
                    <p className="header" >{eventName}</p>
                    <div>
                        <CompanyName style={{marginBottom: '12px'}}> {companyName} </CompanyName>
                        <div className="d-inline-flex">
                        <img src={calendar} height="16px" style={{marginTop : "3px"}}/>
                        &nbsp;
                        <DateTime>
                            {date.getDate()} {getMonthName(date.getMonth())} {date.getFullYear() + ' в '}
                            {date.getHours()}:{('0' + date.getMinutes()).slice(-2)}
                        </DateTime>
                        </div>
                    </div>
                    <div dangerouslySetInnerHTML={{ __html: description }} />
                </div>
            </CenterContainer>
            <Footer style={{padding: "16px 25%"}}>
                {
                    isStudentInvolved 
                        ? 
                        <>
                            <ParticipateButton isInvolved>Я участвую</ParticipateButton> 
                            <CancelButton style={{marginLeft: "10px", padding: "5px 16px", height: "35px"}} onClick={() => setIsStudentInvolved(false)}>Отменить участие</CancelButton>
                        </>
                        : <ParticipateButton type="primary" style={{padding: "9px 24px"}} onClick={() => setIsStudentInvolved(true)}>Принять участие</ParticipateButton>
                }
            </Footer>
        </div>
    );
}